module.exports = __webpack_public_path__ + "static/media/challengeDefaultBackground.23607696.jpg";